import {
  Card as MuiCard,
  CardContent as MuiCardContent,
  CardHeader as MuiCardHeader,
  type CardProps as MuiCardProps,
  type CardContentProps as MuiCardContentProps,
  type CardHeaderProps as MuiCardHeaderProps,
} from '@mui/material';
import { forwardRef } from 'react';

export type CardProps = MuiCardProps;
export type CardContentProps = MuiCardContentProps;
export type CardHeaderProps = MuiCardHeaderProps;

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(props, ref) {
  return <MuiCard ref={ref} {...props} />;
});

export const CardContent = MuiCardContent;
export const CardHeader = MuiCardHeader;
